module.exports = __webpack_public_path__ + "img/girls030.ec1f53e3.png";